export default __webpack_public_path__ + "static/media/gallery06.8ec2f49f.JPG";